import React, { useState, useEffect } from "react";
import headerLayoutWrapper from "../../hoc/headerLayoutWrapper";
import { FaSearch } from "react-icons/fa";
import { getReturns } from "../../services/services";
import moment from "moment";
import Pagination from "../../components/Pagination";
import DataTable from "react-data-table-component";
import Loading from "../../components/loading";
import { toast } from "react-toastify";

const ReturnPage = () => {
  const [returns, setReturns] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filterQuery, setFilterQuery] = useState({});
  const [loading, setLoading] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const mapReturns = (returns = []) =>
    returns.map((item) => {
      const isSale = item.type === "saleReturn";

      return {
        id: item._id,
        type: item.type,
        invoiceNumber: isSale
          ? item.sale?.invoiceNumber
          : item.purchase?.invoiceNumber,

        partyName: isSale
          ? item.sale?.customerId?.name
          : item.purchase?.vendor?.name,

        partyMobile: isSale
          ? item.sale?.customerId?.mobile
          : item.purchase?.vendor?.mobile,

        items: item.product?.name,

        quantity: item.quantity,
        reason: item.reason,
        date: item.date,
      };
    });
  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#0b2b6d",
        color: "#ffffff",
        fontWeight: "600",
        fontSize: "14px",
        textTransform: "uppercase",
      },
    },
  };

  const fetchReturns = async () => {
    setLoading(true);
    try {
      const payload = {
        page: currentPage,
        limit: itemsPerPage,
        ...filterQuery,
      };

      const res = await getReturns(payload);

      if (res.data.success) {
        const { returns, page, totalPages, total } = res.data.response;
        // const sortedData = returns.sort(
        //   (a, b) => new Date(b.date) - new Date(a.date),
        // );
        setReturns(mapReturns(returns));
        setTotalItems(total);
        setCurrentPage(page);
        setTotalPages(totalPages);
      }
    } catch (err) {
      toast.error("Failed to fetch returns");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (params) => {
    setFilterQuery(params);
    setCurrentPage(1);
  };

  useEffect(() => {
    fetchReturns();
  }, [currentPage, itemsPerPage, filterQuery]);

  // const handleDelete = async (id, referenceType) => {
  //   const confirmation = window.confirm(
  //     `Are you sure to delete this ${
  //       referenceType === "saleReturn" ? "sale return" : "purchase return"
  //     }?`
  //   );
  //   if (!confirmation) return;

  //   try {
  //     let response;
  //     if (referenceType === "purchaseReturn") {
  //       response = await deletePurchaseReturn(id);
  //     } else if (referenceType === "saleReturn") {
  //       response = await deleteSaleReturn(id);
  //     }
  //     toastSuccess(response.data.message || "Return deleted successfully");
  //     await fetchReturns();
  //     setSelectedReturn(null);
  //     window.location.reload();
  //   } catch (error) {
  //     console.error("Delete Return Error:", error);
  //     const errorMessage =
  //       error.response?.data?.message ||
  //       error.response?.data?.error ||
  //       error.message ||
  //       "Failed to delete return";
  //     toastError(errorMessage);
  //   }
  // };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const columns = [
    {
      name: "Invoice",
      selector: (row) => row.invoiceNumber,
      sortable: true,
    },
    {
      name: "Party",
      selector: (row) => row.partyName,
      sortable: true,
      // grow: 2,
      wrap: true,
    },
    // {
    //   name: "Mobile",
    //   selector: (row) => row.partyMobile,
    //   // grow: 2,
    // },
    {
      name: "Items",
      selector: (row) => row.items,
      // grow: 2,
    },
    {
      name: "Qty",
      selector: (row) => row.quantity,
      // center: true,
    },
    {
      name: "Type",
      cell: (row) => (
        <span
          className={`fw-bold ${
            row.type === "saleReturn" ? "text-success" : "text-danger"
          }`}
        >
          {row.type === "saleReturn" ? "SALE" : "PURCHASE"}
        </span>
      ),
    },
    {
      name: "Date",
      selector: (row) => moment(row.date).format("DD MMM YYYY"),
      sortable: true,
    },
    {
      name: "Reason",
      selector: (row) => row.reason,
      grow: 2,
      wrap: true,
    },
  ];

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="main" id="main">
            <div className="d-flex align-items-center justify-content-between mb-4">
              <h4 className="mb-0 custom-title">Manage Return Items</h4>
              {/* <div className="d-flex align-items-center gap-2">
            <SearchFilter parties={parties} onSearch={handleSearch} />
          </div> */}
            </div>
            <div className="mb-3 rounded w-100">
              <DataTable
                columns={columns}
                data={returns}
                customStyles={customStyles}
                highlightOnHover
                striped
                responsive
                noDataComponent={
                  <div className="py-4 text-muted text-center">
                    <i className="bi bi-inbox fs-1 d-block mb-2"></i>
                    No returns found
                  </div>
                }
              />
            </div>
            {returns.length > 0 && (
              <Pagination
                page={currentPage}
                totalPages={totalPages}
                limit={itemsPerPage}
                totalItems={totalItems}
                onPageChange={handlePageChange}
                onLimitChange={(newLimit) => {
                  setItemsPerPage(newLimit);
                  setCurrentPage(1);
                }}
              />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default headerLayoutWrapper(ReturnPage);
